import { notificationService } from "@/services/api/features/notificationService";
import { executeAction } from "@/services/api/helpers";

const notificationModules = {
  namespaced: true,

  state: {
    user: JSON.parse(localStorage.getItem("user")) || null,
    notification: [],
    totalNotification: 0,
    totalUnread:0,
    loading: {},
    error: {},
    orderSocketStatus: null,
    paymentSocketStatus: null,
    isSuccessPayment: false,
  },
  getters: {
    isLoading: (state) => (action) => !!state.loading[action],
    getError: (state) => (action) => state.error[action],
    getNotification: (state) => state.notification,
    notiCount: (state) => state.totalNotification,
    unreadNoti: (state) => state.totalUnread,
    getOrderSocketStatus: (state) => state.orderSocketStatus,
    getPaymentSocketStatus: (state) => state.paymentSocketStatus,
    isSuccessPayment: (state) => state.isSuccessPayment,
  },
  mutations: {
    SET_LOADING(state, { action, status }) {
      state.loading = { ...state.loading, [action]: status };
    },
    SET_ERROR(state, { action, message }) {
      state.error = { ...state.error, [action]: message };
    },
    APPEND_NOTIFICATIONS(state, { items, page }) {
      if (page === 1) {
        state.notification = items;
      } else {
        state.notification = [...state.notification, ...items];
      }
    },
    INCREMENT_PAGE(state) {
      state.page += 1;
    },
    CLEAR_NOTIFICATIONS(state) {
      state.notifications = [];
    },
    SET_TOTAL_NOTIFICATION(state, total) {
      state.totalNotification = total;
    },
    SET_TOTAL_UNREAD(state, unread) {
      state.totalUnread = unread;
    },
    SET_ORDER_SOCKET_STATUS(state, status) {
      state.orderSocketStatus = status;
    },
    SET_PAYMENT_SOCKET_STATUS(state, status) {
      state.paymentSocketStatus = status;
    },
    SET_PAYMENT_SUCCESS(state, status) {
      state.isSuccessPayment = status;
    },
  },
  actions: {
    setOrderSocketStatus({ commit }, status) {
      commit("SET_ORDER_SOCKET_STATUS", status);
    },
    setLoading({ commit }, { action, status }) {
      commit("SET_LOADING", { action, status });
    },

    getPaymentSocketStatus({ commit }, { status }) {
      commit("SET_PAYMENT_SOCKET_STATUS", status);
    },
    setPaymentSuccessStatus({ commit }, { status }) {
      commit("SET_PAYMENT_SUCCESS", status);
    },
    setTotalUnread({ commit }, allUnread ) {
      commit("SET_TOTAL_UNREAD", allUnread);
    },

    async getUserNotification({ commit }, params) {
      return executeAction(
        { commit, action: "getUserNotification" },
        () => notificationService.getUserNotification(params),
        {
          success: (data) => {
            commit("APPEND_NOTIFICATIONS", {
              items: data.data?.items || [],
              page: data.data?.pagination?.page || 1,
            });
            commit("SET_TOTAL_NOTIFICATION", data.data?.pagination?.total || 0);
            commit("SET_TOTAL_UNREAD", data.data?.pagination?.totalUnread || 0);
          },
        }
      );
    },
    async patchIsAllowNotiRelation(
      { commit },
      { relationshipId, notificationFlag }
    ) {
      return executeAction({ commit, action: "patchIsAllowNotiRelation" }, () =>
        notificationService.patchIsAllowNotiRelation(relationshipId, notificationFlag)
      );
    },
    async readNotification({ commit }, notificationId) {
      return executeAction({ commit, action: "readNotification" }, () =>
        notificationService.readNotification(notificationId)
      );
    },
    async getNotificationDetail({ commit }, notificationId) {
      return executeAction({ commit, action: "getNotificationDetail" }, () =>
        notificationService.getNotificationDetail(notificationId)
      );
    },
    async readAllNotification({ commit }) {
      return executeAction({ commit, action: "readAllNotification" }, () =>
        notificationService.readAllNotification()
      );
    },
  },
};
export default notificationModules;
